import { Alert, Link } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { lerLojaExcluida } from '../../lib/lojas-admin'
import { URL_HELPDESK } from '../../lib/sistemas-sischef'

interface AvisoLojaExcluidaProps {
  // Loja ainda na lista = suporte, que já vê a faixa vermelha e pode restaurar ali mesmo.
  lojas?: { id: number }[]
}

export function AvisoLojaExcluida({ lojas }: AvisoLojaExcluidaProps): JSX.Element | null {
  const location = useLocation()
  const navigate = useNavigate()
  const excluida = lerLojaExcluida(location.state)

  if (!excluida || lojas?.some((loja) => loja.id === excluida.id)) return null

  function fechar(): void {
    navigate(`${location.pathname}${location.search}${location.hash}`, { replace: true, state: null })
  }

  return (
    <Alert severity="success" sx={{ mb: 3 }} onClose={fechar}>
      Loja <strong>{excluida.nome}</strong> excluída. Se foi engano, fale com o{' '}
      <Link href={URL_HELPDESK} target="_blank" rel="noopener noreferrer" color="inherit" underline="always">
        suporte Sischef
      </Link>
      .
    </Alert>
  )
}
